
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms and Conditions</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Eligibility</h2>
            <p className="text-gray-700 mb-4">
              You must be 18 years or older to participate in GoldenTicketLucky lottery games. 
              Participation is restricted to Australian residents only. By entering any lottery draw, 
              you confirm that you meet these eligibility requirements.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. How to Play</h2>
            <p className="text-gray-700 mb-4">
              To participate in GoldenTicketLucky draws, you must:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Create a valid account with accurate personal information</li>
              <li>Select your numbers or use Quick Pick for random selection</li>
              <li>Pay the required entry fee before the draw closes</li>
              <li>Ensure your contact details are current for prize notifications</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Prizes and Winnings</h2>
            <p className="text-gray-700 mb-4">
              Prize amounts are determined by ticket sales and the number of winners in each division. 
              All prizes must be claimed within 12 months of the draw date. Winners will be notified 
              via email and phone. Prizes over $10,000 require identity verification before payment.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Responsible Gambling</h2>
            <p className="text-gray-700 mb-4">
              GoldenTicketLucky is committed to responsible gambling. We provide tools to help you:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Set spending limits on your account</li>
              <li>Take breaks from playing when needed</li>
              <li>Access support resources if gambling becomes a problem</li>
            </ul>
            <p className="text-gray-700 mb-4">
              If you need help with gambling problems, contact:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Gambling Help Line: +61 35 9294 105</li>
              <li>GambleAware NSW: <a href="https://gambleaware.nsw.gov.au" className="text-yellow-600 underline">gambleaware.nsw.gov.au</a></li>
              <li>BetStop National Self-Exclusion: <a href="https://betstop.gov.au" className="text-yellow-600 underline">betstop.gov.au</a></li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Account Terms</h2>
            <p className="text-gray-700 mb-4">
              You are responsible for maintaining the security of your account and password. 
              GoldenTicketLucky cannot and will not be liable for any loss or damage arising from 
              your failure to comply with this security obligation.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              GoldenTicketLucky's liability is limited to the refund of your entry fee. We are not 
              liable for any technical failures, errors in draw results, or other issues beyond 
              our reasonable control.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
              We reserve the right to modify these terms at any time. Changes will be posted 
              on this page with an updated revision date. Your continued use of our services 
              constitutes acceptance of any changes.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about these Terms and Conditions, please contact us at:
            </p>
            <ul className="list-none text-gray-700 mb-4">
              <li>Email: legal@goldenticketlucky.com</li>
              <li>Phone: 1800 GOLDEN (+61359294105)</li>
              <li>Address: 24 Balmoral Ave, Springvale VIC 3171</li>
            </ul>
            
            <div className="bg-yellow-50 p-6 rounded-lg mt-8">
              <p className="text-gray-700 font-medium">
                Licensed under the NSW Lotteries Act 1996. Licence Number: LIC-2025-001. 
                This is a game of chance. Play responsibly.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Terms;
